import AppComponent from './App.component';
export default AppComponent;